import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UserDao } from '@app/dao/user/user.dao';
import { GoogleMapsLoaderService } from '@app/services/google-maps-loader.service';

@Component({
    selector: 'pr-map',
    templateUrl: './pr-map.component.html',
    styleUrls: ['./pr-map.component.scss'],
    standalone: false
})
export class PrMapComponent implements OnInit {
  @Input() address: any;
  lat: any;
  lng: any;
  mapOptions: google.maps.MapOptions;
  marker: {};
  @Input() height: string = '325px';
  @Input() zoom: any = 16;
  @Input() label: boolean = true;

  constructor(
    private userDao: UserDao,
    private googleMapsLoader: GoogleMapsLoaderService,
  ) {}

  ngOnInit() {
    // Wait for Google Maps API to be loaded
    this.googleMapsLoader.loadScript().subscribe({
      next: () => {
        this.userDao.getGoogleMapPrediction(this.address).subscribe(coord => {
          if (!coord) return;
          this.lat = coord.geometry.location.lat();
          this.lng = coord.geometry.location.lng();
          this.initMap();
        });
      },
      error: err => {
        console.error('Failed to load Google Maps in pr-map', err);
      },
    });
  }

  initMap() {
    setTimeout(() => {
      this.mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
        disableDefaultUI: true,
        gestureHandling: 'none',
      };

      let map = this.mapOptions;
      this.marker = {
        map,
        position: { lng: this.lng, lat: this.lat },
        icon: '/gp/assets/img/ico/marker.png',
      };
      this.mapOptions = {
        center: { lng: this.lng, lat: this.lat },
        zoom: this.zoom,
        disableDefaultUI: true,
        gestureHandling: 'none',
      };
    }, 0);
  }
}
